import first from 'lodash.first';

/**
 * getFirstEntityDate returns the date of the first (latest) data point in the array
 * entity data of the first entity in the response from the API.
 *
 * @method getFirstEntityDate
 * @param  {Array}           entities   The array of entities
 * @param  {Object}          periodType A period type object from the periods map
 * @return {String}                     Unix timestamp (in ms)
 */
function getFirstEntityDate(entities: any[]): any {
  const firstEntity = first<any>(entities);
  const firstData = first<any>(firstEntity?.data);
  return firstData?.date;
}

export default getFirstEntityDate;
